var map = {
	"./0.png": 2181,
	"./1.png": 6908,
	"./2.png": 7591,
	"./3.png": 1806,
	"./4.png": 8750,
	"./5.png": 7976,
	"./6.png": 9955,
	"./7.png": 122,
	"./invalid.png": 5644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6946;